import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairTransferGuideContent } from "../../PairTransferGuideContent";

export default function TransferSpotifyToSpotify() {
    return (
        <GuidesPage
            seoData={seoContent.transferSpotifyToSpotify}
            sections={<PairTransferGuideContent sourceKey="spotify" destKey="spotify" />}
        />
    );
}
